var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"footer-documents"},_vm._l((_vm.documents),function(document){return _c('FooterDocument',{key:document.id,attrs:{"title":document.title,"href":document.link}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }